// src/plugins/vuetify.js

// 1) Vuetify styles
import 'vuetify/styles'

// 2) Vuetify core & components
import { createVuetify } from 'vuetify'
import * as components  from 'vuetify/components'
import * as directives  from 'vuetify/directives'

// 3) Your inline‑SVG wrapper
import SvgIcon from '@/components/SvgIcon.vue'

// 4) Import just the two checkbox paths
import {
  mdiCheckboxBlankOutline,
  mdiCheckboxMarked,
} from '@mdi/js'

// 5) Import Vuetify’s alias table (maps v-checkbox’s built‑in names  
//    like “checkbox-off” and “checkbox-on” to the keys you’re providing below)
import { aliases } from 'vuetify/iconsets/mdi-svg'

// 6) Build your minimal values map
const svgValues = {
  'checkbox-blank-outline': mdiCheckboxBlankOutline,
  'checkbox-marked':        mdiCheckboxMarked,
}

export default createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',       // we’re calling this set “mdi”
    aliases,                 // <-- now Vuetify knows what “checkbox-off” etc. mean
    sets: {
      mdi: {
        component: SvgIcon,  // your <SvgIcon> wrapper
        values:    svgValues // only these two icons get bundled globally
      },
    },
  },
})